import styled from 'styled-components'

const IosVerfiyExtremeCommponents = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    flex-wrap: wrap;

    .ant-select .ant-select-selector {
        height: 100%;
        display: flex;
        align-items: center;
        border: none;
        border-radius: 26px;
        background: #F5F6F7;
        box-shadow: none !important;
    }
`

export default IosVerfiyExtremeCommponents